import { render, staticRenderFns } from "./NoProtocolCard.vue?vue&type=template&id=03884670"
import script from "./NoProtocolCard.vue?vue&type=script&lang=js"
export * from "./NoProtocolCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports